import React, { useEffect, useState } from 'react';
import { Link, useParams, useHistory } from 'react-router-dom';
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  FormGroup,
  Input,
  Row,
  Spinner,
} from 'reactstrap';
import swal from 'sweetalert';

import { GET_BERITA_DETAIL } from 'utils';
import axios from 'axios';
import { UPDATE_BERITA, GET_TOKEN } from 'utils';

export default function EditBerita() {
  const { id } = useParams();
  const idKu = id.split(',');
  const history = useHistory();

  const [gambar, setGambar] = useState('');
  const [gambar2, setGambar2] = useState('');
  const [isi, setIsi] = useState('');
  const [judul, setJudul] = useState('');
  const [kategori, setKategori] = useState('');
  const [penulis, setPenulis] = useState('');
  const [status, setStatus] = useState('');
  const [sumber, setSumber] = useState('');
  const [tanggal, setTanggal] = useState('');
  const [urlFile1, setUrlFile1] = useState('');
  const [urlFile2, setUrlFile2] = useState('');
  const [saveLoading, setSaveLoading] = useState(false);

  // auth

  const [accessToken, setAccessToken] = useState('');

  const refreshToken = async () => {
    try {
      const response = await axios.get(GET_TOKEN + '/token', {
        credentials: 'include',
      });
      setAccessToken(response.data.accessToken);
    } catch (error) {
      if (error.response) {
        history.push('/admin/berita');
      }
    }
  };
  //auth

  useEffect(() => {
    refreshToken();
    getDetailBerita();
  }, []);

  const getDetailBerita = async () => {
    var data1 = [];
    try {
      const response = await axios.get(GET_BERITA_DETAIL + `${idKu[0]}`);
      data1 = response.data.data[0];

      if (data1) {
        setUrlFile1(data1.gambar.split(',')[0]);
        setUrlFile2(data1.gambar.split(',')[1]);
        setIsi(data1.isi);
        setJudul(data1.judul);
        setKategori(data1.kategori);
        setPenulis(data1.penulis);
        setStatus(data1.status);
        setSumber(data1.sumber);
        setTanggal(data1.tanggal);
      } else {
      }
      // berita.gambarKu = berita.gambar.split(',');
      // berita.isiKu = berita.isi.split('##');
    } catch (error) {
      console.error(error);
    }
  };

  function onChange1(e) {
    let uploaded = e.target.files[0];
    setUrlFile1(URL.createObjectURL(uploaded));
    setGambar(e.target.files[0]);
  }

  function onChange2(e) {
    let uploaded = e.target.files[0];
    setUrlFile2(URL.createObjectURL(uploaded));
    setGambar2(e.target.files[0]);
  }

  const handleSubmit = async (event) => {
    event.preventDefault();
    setSaveLoading(true);

    if (
      isi &&
      judul &&
      kategori &&
      sumber &&
      penulis &&
      status &&
      tanggal &&
      gambar &&
      gambar2
    ) {
      //action
      // this.props.dispatch(updateJersey(this.state));

      const formData = new FormData();
      formData.append('photo', gambar);
      formData.append('photo', gambar2);

      formData.append('isi', isi);
      formData.append('judul', judul);
      formData.append('kategori', kategori);
      formData.append('penulis', penulis);
      formData.append('status', status);
      formData.append('sumber', sumber);
      formData.append('tanggal', tanggal);
      formData.append('idAdmin', idKu[1]);

      const response = await axios.patch(
        UPDATE_BERITA + `${idKu[0]}`,
        formData,

        {
          credentials: 'include',
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );

      if (response.data.success === 1) {
        swal('Success', 'Berita berhasil diedit', 'success');
        history.push('/admin/berita');
      }
    } else {
      swal('Failed', 'Maaf semua form wajib diisi', 'error');
    }
    setSaveLoading(false);
  };

  return (
    <div className='content'>
      <Row>
        <Col>
          <Link to='/admin/berita' className='btn btn-primary'>
            Kembali
          </Link>
        </Col>
      </Row>

      <Row>
        <Col>
          <Card>
            <CardHeader tag='h4'>Edit Berita</CardHeader>
            <CardBody>
              <form onSubmit={(event) => handleSubmit(event)}>
                <Row>
                  <Col md={6}>
                    <Row>
                      <Col>
                        <img
                          src={urlFile1}
                          width='300'
                          alt='Foto Berita (satu)'
                        />
                        <FormGroup>
                          <label>Foto Berita (satu)</label>
                          <Input
                            type='file'
                            name='image1'
                            accept={'image/*'}
                            onChange={(event) => onChange1(event, 'imageToDB1')}
                          />
                        </FormGroup>
                      </Col>
                      <Col>
                        <img
                          src={urlFile2}
                          width='300'
                          alt='Foto Berita (dua)'
                        />
                        <FormGroup>
                          <label>Foto Berita (dua)</label>
                          <Input
                            type='file'
                            name='image2'
                            accept={'image/*'}
                            onChange={(event) => onChange2(event, 'imageToDB2')}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                  </Col>
                  <Col md={6}>
                    <FormGroup>
                      <label>Judul Berita</label>
                      <Input
                        type='text'
                        value={judul}
                        name='nama'
                        onChange={(event) => setJudul(event.target.value)}
                      />
                    </FormGroup>

                    <Row>
                      <Col md={6}>
                        <FormGroup>
                          <label>Kategori</label>
                          <Input
                            type='select'
                            name='liga'
                            value={kategori}
                            onChange={(event) =>
                              setKategori(event.target.value)
                            }
                          >
                            <option value=''>--Pilih--</option>
                            <option value='Kepala Daerah'>Kepala Daerah</option>
                            <option value='Lintas OPD'>Lintas OPD</option>
                            <option value='Publik'>Publik</option>
                          </Input>
                        </FormGroup>
                      </Col>
                      <Col md={6}>
                        <FormGroup>
                          <label>Penulis</label>
                          <Input
                            type='text'
                            value={penulis}
                            name='harga'
                            onChange={(event) => setPenulis(event.target.value)}
                          />
                        </FormGroup>
                      </Col>
                    </Row>

                    <Row>
                      <Col md={6}>
                        <FormGroup>
                          <label>Status</label>
                          <Input
                            type='text'
                            value={status}
                            name='berat'
                            onChange={(event) => setStatus(event.target.value)}
                          />
                        </FormGroup>
                      </Col>
                      <Col md={6}>
                        <FormGroup>
                          <label>Sumber</label>
                          <Input
                            type='text'
                            value={sumber}
                            name='jenis'
                            onChange={(event) => setSumber(event.target.value)}
                          />
                        </FormGroup>
                      </Col>
                    </Row>

                    {/* <Row>
                      <Col md={6}></Col>
                      <Col md={6}>
                        <FormGroup>
                          <label>Ready</label>
                          <Input type='select' name='ready' value=''>
                            <option value={true}>Ada</option>
                            <option value={false}>Kosong</option>
                          </Input>
                        </FormGroup>
                      </Col>
                    </Row> */}
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <FormGroup>
                      <label>Isi Berita</label>
                      <Input
                        type='textarea'
                        style={{
                          resize: 'vertical',
                          height: '400px',
                        }}
                        value={isi}
                        name='text'
                        id='exampleText'
                        onChange={(event) => setIsi(event.target.value)}
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    {saveLoading ? (
                      <Button color='primary' type='submit' disabled>
                        <Spinner size='sm' color='light' /> Loading
                      </Button>
                    ) : (
                      <Button type='submit' color='danger' className='ml-2'>
                        <i className='nc-icon nc-basket'></i> Simpan
                      </Button>
                    )}
                  </Col>
                </Row>
              </form>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
}
